import { CalendarIcon as Calendar } from "lucide-react";
import React from "react";
import { CongratsActionButton } from "./CongratsActionButton";

export const CongratsCalendarActionButton = ({
  children,
  onClick,
}: {
  children: React.ReactNode;
  onClick?: () => void;
}) => {
  return (
    <CongratsActionButton onClick={onClick}>
      <Calendar className="h-[24px] w-[24px] [&_svg:not([class*='size-'])]:size-4" />
      {children}
    </CongratsActionButton>
  );
};
